import { useSetRecoilState } from "recoil";
import { billingAtom } from "../store/billingAtom";
import { useCallback, useEffect, useRef } from "react";
import api from "../api";

const useCompanyUsage = () => {
  const setValue = useSetRecoilState(billingAtom);
  const hasFetched = useRef(false);

  const cb = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    try {
      const { data } = await api.get("/api/company/usage");

      if (data) {
        setValue(data);
      }
    } catch (error) {
      console.error("Failed to fetch billing data:", error);
    }
  }, [setValue]);

  useEffect(() => {
    cb();
  }, [cb]);
};

export default useCompanyUsage;
